import styled from '@emotion/styled'

import { Grid, Card } from '@mui/material'

import { Panel, SwitchSection, Section, HebrewSpan } from '../../Common'

import RadioCards from '../../Components/RadioCards';

import Hours from '../Components/Hours';

import { usePageData } from '../../../../contexts/PageData';

const GeneralTab = () => {

  const { data } = usePageData() || {};

  console.log(data?.data, "data");

  return (
    <Panel>

      <SwitchSection title="Display Pickups" description="Add column for pickups in the calendar" switchName="display_pickups" />

      <SwitchSection title="Display Parshios" description="Display Parsha of the week in the calendar" switchName="display_parshios" />

      <SwitchSection title="Display Zmanim" description="Display Zmanim such as Candle Lighting and Havdala in the calendar"  switchName="display_zmanim" />

      <SwitchSection title="Display Holidays" description="Display Major Holidays like Pesach and Sukkos in the calendar" switchName="display_holidays" />

      <SwitchSection title="Display Rosh Chodesh" description="Display Rosh Chodesh in the calendar" switchName="display_rosh_chodesh" />

      <Section title="Shabbos Booking" description="Select whether Shabbos can be booked">
        <RadioCards options={[
          { title: "Enabled", description: "Enable booking for Shabbos", name: "enabled" },
          { title: "Enabled with warning", description: "Booking is enabled but you will get a warning", name: "warning" },
          { title: "Disabled", description: "Shabbos can not be booked", name: "disabled" },
        ]}
        fieldName="shabbos_booking"
        />
      </Section>

      <Section title="Yom Tov Booking" description="Select whether Yom Tov can be booked">
        <RadioCards options={[
          { title: "Enabled", description: "Enable booking for Yom Tov", name: "enabled" },
          { title: "Enabled with warning", description: "Booking is enabled but you will get a warning", name: "warning" },
          { title: "Disabled", description: "Yom Tov can not be booked", name: "disabled" },
        ]}
        fieldName="yom_tov_booking"
        />
      </Section>

      <Section title="Chol Hamoed Booking" description="Select whether Chol Hamoed can be booked">
        <RadioCards options={[
          { title: "Enabled", description: "Enable booking for Chol Hamoed", name: "enabled" },
          { title: "Enabled with warning", description: "Booking is enabled but you will get a warning", name: "warning" },
          { title: "Disabled", description: "Chol Hamoed can not be booked", name: "disabled" },
        ]}
        fieldName="chol_hamoed_booking"
        />
      </Section>

      <Section title="Rosh Chodesh Booking" description="Select whether Rosh Chodesh can be booked">
        <RadioCards options={[
          { title: "Enabled", description: "Enable booking for Rosh Chodesh", name: "enabled" },
          { title: "Enabled with warning", description: "Booking is enabled but you will get a warning", name: "warning" },
          { title: "Disabled", description: "Rosh Chodesh can not be booked", name: "disabled" },
        ]}
        fieldName="rosh_chodesh_booking"
        />
      </Section>

      <Section title={<span>Set <HebrewSpan>צאת הכוכבים</HebrewSpan></span>} description="Set Tzeis Time">
        <RadioCards options={[
          { title: "72 Minutes", description: <span>Set the <HebrewSpan>צאת הכוכבים</HebrewSpan> to 72 minutes. <HebrewSpan>לפי שיטת ר"ת</HebrewSpan></span>, name: "72min" },
          { title: <span><HebrewSpan>לפי האופק</HebrewSpan> (3 Stars)</span>, description: <span>Set the <HebrewSpan>צאת הכוכבים, לפי האופק</HebrewSpan> </span>, name: "horizon" },
        ]}
        fieldName="tzeis"
        />
      </Section>

      <Section title={<span>Set <HebrewSpan>זמן הדלקת נרות</HebrewSpan></span>} description="Set Candle Lighting">
        <RadioCards options={[
          { title: "15 Minutes", description: <span>Set the <HebrewSpan>זמן הדלקת נרות</HebrewSpan> to 15 minutes before Shkiah.</span>, name: "15min" },
           { title: "18 Minutes", description: <span>Set the <HebrewSpan>זמן הדלקת נרות</HebrewSpan> to 18 minutes before Shkiah.</span>, name: "18min" },
        ]}
        fieldName="candle_lighting"
        />
      </Section>

      <Section title="Calendar View Density" description="Adjust how much vertical space each hour takes up in the calendar grid. Larger heights make it easier to see appointment details.">
        <RadioCards options={[
          { title: "Dense View", description: "Very compact view. With the dense view, event details might not be visible by default", name: "5" },
          { title: "Compact View", description: "With a compact view, event details are hidden by default", name: "10" }, 
          { title: "Medium View", description: "With the standard view, event details are visible by default", name: "20" },
          // { title: "Spacious View", description: "With the spacious view, event details are visible by default", name: "10" },
          { title: "Standard View", description: "With the standard view, event details are visible by default", name: "30" },
        ]}
        fieldName="view_density"
        />
      </Section>

      <Section 
        title="Calendar View Time Granularity" 
        description="Choose how many segments to display per hour to control the level of detail in your schedule."
      >
        <RadioCards 
          fieldName="hourly_divisions"
          options={[
            { 
              title: "5 Minutes", 
              description: "Maximum precision for back-to-back scheduling.", 
              name: 12 
            }, 
            { 
              title: "10 Minutes", 
              description: "Increased detail for back-to-back scheduling.", 
              name: 6 
            },
            { 
              title: "15 Minutes", 
              description: "The standard balance between visibility and granularity.", 
              name: 4 
            },
            { 
              title: "30 Minutes", 
              description: "A clean, compact overview for a clear daily layout.", 
              name: 2 
            },
            { 
              title: "None (hours only)", 
              description: "A compact overview for a clear weekly layout.", 
              name: 1 
            }
          ]}
        />
      </Section>

      <Section 
        title="Select Start and End Time" 
        description="Select the hours to display in the calendar. Default is 0 to 24 hours."
      >
        <Hours />
      </Section>

      <SwitchSection title="Show Non-Working Hours" description="Display non-working hours on the calendar" switchName="display_non_working_hours" />

    </Panel>
  )
};

export default GeneralTab;